import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getListTaiSan, updateDataSearch } from "actions/DanhSachTaiSan/";
import { SearchTaiSan } from "./SearchNangCao/SearchTaiSan";

import { Headersub } from "../GenericComponent/HeaderSub/headersub";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";

export const AddTaiSanBtn = () => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTaiSan); //dataSearchTaiSan dinh nghia o rootreducer
  const setModalShow = () => {
    //this.setState({ showThemMoiNhanVay: !this.state.showThemMoiNhanVay });
  };

  const updateState = (field, value) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: value,
      }),
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        }),
      );
      dispatch(getListTaiSan(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  const onSearch = () => {
    dispatch(getListTaiSan(dataSearch));
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="hide-table-main show-mobile-main hidden-des-main">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 15,
          marginBottom: 15,
        }}
      >
        <div style={{ display: "block" }}>
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="media-home align-center-home">
                <div className="bg-icon-bredcrumb">
                  <i class="mdi mdi-car"></i>
                </div>
                <div className="media-body-home">
                  <h2 className="text-info-home">Danh sách tài sản</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div>
          <button
            type="button"
            className="btn btn-border-new"
            onClick={setModalShow}
          >
            <i className="mdi mdi-plus"></i> Thêm mới
          </button>
        </div> */}
      </div>

      <form className="form row bg-search-form form-mobile-search">
        <div className="text-right  search-p mb-1  " style={{ width: "100%" }}>
          <div className="row col-sm-12">
            <div className="col-sm-8">
              <div className="search-mobile-new">
                <fieldset className="form-group position-relative mb-0">
                  <input
                    type="text"
                    className="form-control input-sm"
                    id="iconLeft1"
                    placeholder="Tên khách hàng"
                    onChange={updateTextValue("tenkhachhang")}
                    onKeyDown={handleKeyDown}
                    value={dataSearch.tenkhachhang}
                  />
                  <div className="form-control-position">
                    <a href={() => false} onClick={onSearch}>
                      <i className="la la-search"></i>
                    </a>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="col-sm-4">
              <div class="icon-search-mobile">
                <a
                  href={() => false}
                  className="card-link blue darken-2 text-search-new"
                  style={{ marginBottom: "-3px" }}
                  onClick={handleShow}
                >
                  <i>
                    <PopoversBootrap
                      contentText="Tìm kiếm nâng cao"
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <img
                        className="icon-bred-home"
                        src="/app-assets/images/icon-fitter-v2.png"
                        alt=""
                        style={{
                          scale: "0.9",
                          verticalAlign: "sub",
                          marginTop: "-2px",
                        }}
                      />
                      {/* <i className="mdi mdi-download"></i> */}
                    </PopoversBootrap>
                  </i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </form>
      {show && <SearchTaiSan show={show} onHide={handleClose} />}
    </div>
  );
};
